import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import { Input, Button, Empty } from 'antd';
import ItemTicket from './ItemTicket';
import ItemTicketClose from './ItemTicketClose';
import { ReactComponent as Megafon } from '../../../images/megafon.svg';
import { ReactComponent as Arrow } from '../../../images/arrow_back.svg';
import { ReactComponent as Plus } from '../../../images/plus.svg';
import { ReactComponent as Group } from '../../../images/group_users.svg';

const Wrapper = styled.div`
  &&& {
    div {
      .item-close {
        &:nth-child(1) {
          border-top: 1px solid #e0e0e0;
        }
      }
    }
    .plus {
      background: #eaf4ff;
      svg {
        fill: #4b97e9;
      }
      &:hover {
        background: #4b97e9;
        svg {
          fill: white;
        }
      }
    }
    .mailing-item {
      &:hover {
        background: #4b97e9;
        color: white;
        .date {
          color: white;
        }
        svg {
          path {
            stroke: white;
          }
        }
      }
    }
  }
`;

function Bar({
  mailing,
  setMailing,
  open,
  close,
  openDialog,
  currentTiket,
  openCloseDialog,
}) {
  const [name, setName] = useState(false);
  const { t } = useTranslation();
  return (
    <Wrapper>
      <div>
        {!mailing && (
          <>
            <div className="pr-30 pl-60 items-center flex justify-between pt-28 pb-28">
              <div className="text-20  font-semibold text-black">
                {t('activeTickets')}
              </div>
              <Megafon
                className="cursor-pointer"
                onClick={() => {
                  setMailing(!mailing);
                }}
              />
            </div>
            {open ? (
              open.length !== 0 ? (
                map(open, (item) => {
                  return (
                    <ItemTicket
                      key={item.id}
                      last={item.last_message}
                      currentTiket={currentTiket}
                      name={`${item.client.first_name} ${item.client.last_name}`}
                      theme={item.last_message.text}
                      count={item.unread_messages_count}
                      id={item.id}
                      openDialog={openDialog}
                    />
                  );
                })
              ) : (
                <Empty />
              )
            ) : null}
            <div className="pr-30 pl-60 items-center flex justify-between pt-28 pb-28">
              <div className="text-20  font-semibold text-black">
                {t('closeTickets')}
              </div>
            </div>
            {close ? (
              close.length !== 0 ? (
                map(close, (item) => {
                  return (
                    <ItemTicketClose
                      key={item.id}
                      currentTiket={currentTiket}
                      className="item-close"
                      name={`${item.client.first_name} ${item.client.last_name}`}
                      last={item.last_message.text}
                      id={item.id}
                      openDialog={openCloseDialog}
                    />
                  );
                })
              ) : (
                <Empty />
              )
            ) : null}
          </>
        )}
        {mailing && (
          <>
            <div className="pr-30 pl-19 items-center flex pt-28 pb-28">
              <Arrow
                className="cursor-pointer mr-23"
                onClick={() => {
                  setMailing(!mailing);
                }}
              />
              <Megafon
                className="cursor-pointer mr-23"
                onClick={() => {
                  setMailing(!mailing);
                }}
              />
              <div className="text-20  font-semibold text-black">
                {t('massMailing')}
              </div>
            </div>
            {name && (
              <div
                style={{ background: '#EEEEEE' }}
                className="h-83 cursor-ponter flex items-center pl-60"
              >
                <Input
                  className="rounded-small italic"
                  placeholder="enter mailing name"
                />
                <Button
                  className="tflex items-center hover:text-red"
                  type="link"
                >
                  <span className="border-b-1 border-dotted">{t('save')}</span>
                </Button>
              </div>
            )}
            <>
              <div
                onClick={() => {
                  setName(!name);
                }}
                className="plus h-83 text-primary cursor-pointer flex items-center pl-60 hover:bg-primary hover:text-white"
              >
                <Plus className="mr-15" />
                {t('createNewMails')}
              </div>
              <div className="mailing-item bg-white pl-61 pr-31 pt-20 pb-34">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="date text-graytext mb-14">
                      12:45 | 12.05.2020
                    </div>
                    <div className="font-bold">{t('payLongTime')}</div>
                  </div>
                  <div className="flex items-center">
                    <Group className="mr-15" />
                    <div className="font-bold">150/200</div>
                  </div>
                </div>
              </div>
            </>
          </>
        )}
      </div>
    </Wrapper>
  );
}

Bar.propTypes = {};

export default Bar;
